import ApplicationAdapter from './application';

export default class ByodAdapter extends ApplicationAdapter {
  namespace = 'byod';
}
